import React, { useEffect, useState } from "react";
import "./About.css";

function useCountUp(end, duration = 1500) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let start = 0;
    const startTime = performance.now();

    function animate(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // ease-out
      const current = Math.floor(start + (end - start) * eased);
      setValue(current);
      if (progress < 1) requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }, [end, duration]);

  return value;
}

export default function About() {
  const years = useCountUp(50, 1500);
  const projects = useCountUp(500, 1600);

  return (
    <section id="about" className="about container">
      <header className="about-header">
        <h2 className="about-title">About Us</h2>
        <p className="about-intro">
          For over five decades, <strong>Maa Bhagwati Constructions</strong> has
          created homes and commercial spaces that honour Rajasthan&apos;s warm
          palette, detailed craftsmanship, and Vastu‑aligned planning.
        </p>
        <p className="about-intro">
          From bespoke residences to landmark developments and sensitive heritage
          restorations, every project blends traditional wisdom with modern
          construction technology for spaces that feel harmonious, efficient,
          and built to last.
        </p>
      </header>

      <ul className="facts" aria-label="Company highlights">
        <li>
          <strong>{years}+</strong>
          <span>Years of experience</span>
        </li>
        <li>
          <strong>{projects}+</strong>
          <span>Projects completed</span>
        </li>
        <li>
          <strong>VASTU‑LED</strong>
          <span>Layouts, light and airflow</span>
        </li>
      </ul>

      <article className="vastu-card">
        <div className="vastu-text">
          <h3>VASTU ALIGNED DESIGN</h3>
          <p>
            Entrances, rooms and courtyards are planned to respect sunlight,
            cross‑ventilation and the natural flow of energy, while staying
            practical for modern living.
          </p>
          <ul>
            <li>Thoughtful orientation of living and sleeping zones</li>
            <li>Natural light and airflow as core design tools</li>
            <li>Use of warm, locally sourced materials</li>
          </ul>
        </div>

        <div className="vastu-image" aria-hidden="true">
          <img
            src={require("./pictures/vastu.png")}
            alt="Vastu-inspired home layout"
          />
        </div>
      </article>
    </section>
  );
}
